import { render, staticRenderFns } from "./CustomerProcessList.vue?vue&type=template&id=c0aa350e&scoped=true"
import script from "./CustomerProcessList.vue?vue&type=script&lang=js"
export * from "./CustomerProcessList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0aa350e",
  null
  
)

export default component.exports